<template>
    <div class="hiq-calendar__search-info">
        <p class="show-for-sr">
            {{`${translations.found} ${total} ${translations.hits}`}}
        </p>
        <div v-if="(filter.categories && filter.categories.length > 0) || (filter.startDate && filter.startDate !== '') || (filter.endDate && filter.endDate !== '')">
            <button class="hiq-button-black" @click="clearFilters">{{translations.clearFilters}}</button>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { newSearch } from '../store/actions';
export default Vue.extend({
    name: 'seach-info',
    methods: {
        clearFilters() {
            this.$store.commit({
                type: 'setFilter',
                payload: {
                    startDate: '',
                    endDate: '',
                    categories: []
                }
            });
            this.$store.dispatch(newSearch())
        }
    },
    computed: {
        events() {
            return this.$store.state.events;
        },
        total() {
            return this.$store.state.total;
        },
        translations() {
            return this.$store.state.translations;
        },
        filter() {
            return this.$store.state.filter;
        }
    }
})
</script>